import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, FormControlLabel, Radio, Typography } from '@material-ui/core'
import { lighten, makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const useClasses = makeStyles((theme) => {
  return {
    formControlLabel: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      border: `1px solid`,
      borderColor: lighten(theme.palette.primary.main, 0.5),
      borderRadius: theme.shape.borderRadius,
      margin: 0,
      padding: theme.spacing(2),
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
    },
    selected: {
      borderColor: theme.palette.primary.main,
      background: lighten(theme.palette.primary.main, 0.92),
    },
  }
})

export type IconRadioButtonOption = {
  title: string
  subtitle?: string
  faIcon: IconDefinition
  value: string
  selected: boolean
}

type IconRadioButtonProps = {
  option: IconRadioButtonOption
}

const IconRadioButton = ({ option }: IconRadioButtonProps) => {
  const classes = useClasses()
  const { title, subtitle, faIcon, value, selected } = option
  return (
    <Box py={1}>
      <FormControlLabel
        value={value}
        control={
          <Radio
            color="primary"
            checked={selected}
          />
        }
        className={cn(classes.formControlLabel, {
          [classes.selected]: selected,
        })}
        label={
          <Box
            display="flex"
            alignItems="center"
          >
            <Box mr={2}>
              <FontAwesomeIcon icon={faIcon} />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              textAlign="left"
            >
              <Typography
                variant="button"
                color="textPrimary"
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography
                  variant="caption"
                  color="textPrimary"
                >
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>
        }
        labelPlacement="start"
      />
    </Box>
  )
}

export default IconRadioButton
